import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://icaqghpgcoapikttehjg.supabase.co'; // À récupérer sur ton dashboard
const supabaseAnonKey = 'sb_publishable_7nFecSfzP1uxlrIRKOwSJA_zIf8VfgR'; // À récupérer sur ton dashboard

export const supabase = createClient(supabaseUrl, supabaseAnonKey);